import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import './SectionHeader.css';

export interface HeaderControl {
  id: string;
  icon: IconDefinition;
  tooltip: string;
  onClick: () => void;
  disabled?: boolean;
}

interface SectionHeaderProps {
  title: string;
  showBackButton?: boolean;
  onBack?: () => void;
  controls?: HeaderControl[];
  isLoading?: boolean; // Optional: to show a loading indicator or disable controls
}

const SectionHeader: React.FC<SectionHeaderProps> = ({ title, showBackButton, onBack, controls, isLoading }) => {
  return (
    <div className="section-header">
      {showBackButton && onBack && (
       <button onClick={onBack} className="bg-transparent border-none p-1 mr-3 text-xl text-text-dark hover:secondary-color transition-colors duration-200" title="Change Team">
          <FontAwesomeIcon icon={faArrowLeft} />   
        </button>     
      )}
      <h3 className="section-header-title">{title}</h3>
      {controls && controls.length > 0 && (
        <div className="section-header-controls">
          {controls.map(control => (
            <button
              key={control.id}
              className="section-header-control-button"
              onClick={control.onClick}
              title={control.tooltip}
              disabled={isLoading || control.disabled}
            >
              <FontAwesomeIcon icon={control.icon} />
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default SectionHeader;